<!-- Modal -->
<div id="register">
    <div class="modal-content ">
        <div class="modal-header mt-5 border-0">
          <h3 class="modal-title text-center m-auto" id="registerLabel" style="z-index: 1; color:#00008b">Crea tu cuenta</h3>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <i class="bi-x modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click');"></i>
        </div>
        <div class="modal-body">
          <div class="row ">
            <div class="col-lg-2"></div>
            <div class="col-lg-8">             
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login mb-4">
                <div class="form-control">
                    <p class="mb-1">Nombre de la Agencia</p>
                    <input type="text" formControlName="agencia" class="w-100">
                    <div *ngIf="submitted && f.agencia.errors" class="text-danger">
                      <div *ngIf="f.agencia.errors.required">Nombre de la Agencia es requerido.</div>
                    </div>
                </div>
                <div class="form-control" >
                    <label >Foto de perfil</label>
                    <input type="file" id="loadImagen" name="imagen" style="display:none"
                      accept="image/jpeg, image/jpg, image/png" (change)="fileEvent($event)"/>
                    <div class="d-flex img-tour justify-content-end align-items-center flex-column radius-10">
                      <img *ngIf="!file" src="../assets/images/body/tours/01.jpg" class="h-100" alt="" >
                      <img *ngIf="file" [src]="localUrl" class="h-100" alt="" >                      
                      <div *ngIf="submitted && !file" class="text-danger">
                        Foto de perfil es requerida.                      
                      </div>
                      <div *ngIf="file && fileToBig" class="text-danger">
                        El archivo seleccionado excede los 2MB                     
                      </div>
                    </div>
                    
                    <label for="loadImagen" class="btn btn-lg btn-primary rounded-pill text-center btn-reservar align-self-center mt-lg-0 mt-4">Cargar imagen</label>
                </div>                
                <div class="form-control">
                  <p class="mb-1">Correo electrónico</p>
                  <input type="email" formControlName="email" class="w-100">
                  <div *ngIf="submitted && f.email.errors" class="text-danger">
                    <div *ngIf="f.email.errors.required">Correo electrónico es requerido.</div>
                    <div *ngIf="f.email.errors.pattern">La dirección de correo no es válida.</div>
                  </div>
                </div>
                <div class="form-control">
                  <p class="mb-1">Crear contraseña</p>
                  <input type="password" formControlName="password" class="w-100">
                  <div *ngIf="submitted && f.password.errors" class="text-danger">
                    <div *ngIf="f.password.errors.required">Contraseña es requerida.</div>
                  </div>
                </div>
                <div class="form-control">
                  <p class="mb-1">Confirmar contraseña</p>
                  <input type="password" formControlName="confirmPassword" class="w-100">
                  <div *ngIf="submitted && f.confirmPassword.errors" class="text-danger">
                    <div *ngIf="f.confirmPassword.errors.required">Confirmar contraseña es requerido.</div>
                    <div *ngIf="f.confirmPassword.errors.confirmedValidator">Repita su contraseña. No coinciden.</div>
                  </div>
                </div>
                <div class="form-control">
                    <p class="mb-1">Nombre del vendedor</p>
                    <input type="text" formControlName="vendedor" class="w-100">
                    <div *ngIf="submitted && f.vendedor.errors" class="text-danger">
                      <div *ngIf="f.vendedor.errors.required">Nombre del vendedor es requerido.</div>
                    </div>
                </div>
                <div class="form-control">
                    <p class="mb-1">Dirección</p>
                    <input type="text" formControlName="direccion" class="w-100">
                    <div *ngIf="submitted && f.direccion.errors" class="text-danger">
                      <div *ngIf="f.direccion.errors.required">Dirección es requerida.</div>
                    </div>
                </div>
                <div class="form-control">
                  <p class="mb-1">Teléfono</p>
                  <div class="position-relative">
                    <select formControlName="code" class="cod-pais" id="">
                      <option value="+54" selected>+54</option>
                      <option value="+55">+55</option>
                      <option value="+56">+56</option>
                    </select>
                    <input type="text" formControlName="telefono" class="w-100 tel" (keypress)="keypressTelefono($event)">
                  </div>
                  <div *ngIf="submitted && f.telefono.errors" class="text-danger">
                    <div *ngIf="f.telefono.errors.required">Teléfono es requerido.</div>
                  </div>                  
                </div>
                <div class="form-control" >
                    <p class="mb-1">Razón social</p>
                    <input type="text" formControlName="razonSoc" class="w-100">
                </div>
                <div class="pd-b" style="height: auto !important;">
                    <p class="mb-1">Redes sociales</p>
                </div>
                <div class="pd-b d-flex align-items-center flex-row">
                    <img src="assets/images/body/icons/twitter.svg" class="pe-3" alt="">
                    <input type="text" formControlName="twitter" class="w-100">
                </div>
                <div class="pd-b d-flex align-items-center flex-row">
                    <img src="assets/images/body/icons/facebook.svg" class="pe-3" alt="">
                    <input type="text" formControlName="facebook" class="w-100">
                </div>
                <div class="pd-b d-flex align-items-center flex-row">
                    <img src="assets/images/body/icons/instagram.svg" class="pe-3" alt="">
                    <input type="text" formControlName="instagram" class="w-100">
                </div>
                <div class="pd-b">
                  <div class="align-items-center d-flex justify-content-center text-center flex-row">
                      <input type="radio" formControlName="terminos" value="acepto" class="align-middle text-primary">
                        <p style="cursor: pointer;"  class="text-secondary mb-0 ps-3 z-index--top"> He leído los <a  (click)="openTerminos()" class="text-bold modal-link" style="cursor: pointer;">términos y condiciones.</a></p>
                  </div> 
                  <div *ngIf="submitted && f.terminos.errors" class="text-danger">
                    <div *ngIf="f.terminos.errors.required">Por favor, lea los términos y condiciones </div>
                  </div>
                </div>
                <div class="form-control text-center mt-4">
                    <button type="submit" class="align-self-center border-2 btn btn-lg btn-outline-primary btn-reservar rounded-pill text-center">Registrarme</button>
                </div>
              </form> 
            </div>
            <div class="col-lg-2"></div>
          </div>
        </div>
        <div class="modal-footer mb-5 border-0">
          <img src="assets/images/body/bg-login-2.svg" alt="">
        
        </div>
      </div>    
</div>
